import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=cbe2a73c&scoped=true"
import script from "./ListPage.vue?vue&type=script&lang=js"
export * from "./ListPage.vue?vue&type=script&lang=js"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=cbe2a73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe2a73c",
  null
  
)

export default component.exports